<template>
  <div class="news">
    <div class="container">
      <div class="header">
        <div class="title">
          <div class="en">
            <p>News Media</p>
          </div>
          <div class="cn">新闻资讯</div>
        </div>
      </div>
      <div class="newslist flex">
        <swiper :options="swiperOption" ref="newsSwiper" id="newsSwiper">
          <swiper-slide v-for="item in news" :key="item.ID">
            <NewsItem :item="item"/>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import NewsItem from "@/components/NewsItem.vue";
import { mapActions, mapState } from "vuex";
import { getNewsUrl } from "@/util/lang.js";
export default {
  components: {
    swiper,
    swiperSlide,
    NewsItem
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langNewtype: state => state.langNewtype,
      currentnewtid: state => state.currentnewtid
    })
  },
  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
    // console.log(this.langProducttype[this.lang])
  },
  beforeDestroy() {
    this.setCurrentnewtid("");
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".newslist .swiper-pagination",
          clickable: true
        },
        notNextTick: true,
        loop: true,
        init: false,
        slidesPerView: 3,
        on: {
          init: function(){
            if(document.body.offsetWidth<768){
              this.params.slidesPerView=1
            }else{
              this.params.slidesPerView=3
            }
          },
          resize: function(){
            //窗口变化了
            if(this.width<768){
              this.params.slidesPerView=1
            }else{
              this.params.slidesPerView=3
            }
          }
        }
      },
      news: []
    };
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "fetchData"
  },
  methods: {
    ...mapActions(["setCurrentnewtid"]),
    fetchData() {
      this.setNews();
    },
    async setNews() {
      // console.log('获取数据')
      this.page = 1;
      const url = getNewsUrl(this.lang, "", this.page);
      this.$$axios.get(url).then(res => {
        this.news = res.data.newsArr;
        this.$nextTick(()=>{
          this.$refs.newsSwiper.swiper.init()
        })
      });
    }
  }
};
</script>

<style scoped>
.news {
  padding: 50px 0;
}
.news .container {
  max-width: 1500px;
  margin: 0 auto;
}
.news .header {
  max-width: 390px;
  padding-top: 60px;
}
.news .title {
  color: #004b94;
  border-bottom: 1px solid #b6b3be;
  padding: 20px;
}
.news .title .en {
  font-size: 50px;
}
.news .title .cn {
  font-size: 35px;
}
.news .newslist {
  position: relative;
}
.news .newslist .swiper-pagination {
  width: 100%;
  bottom: 0;
}
@media (max-width: 768px) {
  .news .header{
    padding-top: 0;
  }
  .news .title .en{
    font-size: 24px;
  }
  .news .title .cn{
    font-size: 20px;
  }
}
</style>
<style>
.news .newslist .swiper-pagination .swiper-pagination-bullet {
  width: 50px;
  height: 1px;
  border-radius: 0;
  background-color: #b4b4b4;
  opacity: 1;
  margin: 0 5px;
}
.news .newslist .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #004b94;
}
</style>



